export const DEFAULT_DOCUMENT_TITLE = `OOO. AI Trip Generator`;
export const DEFAULT_SHARE_URL = 'https://trips.takemeoutofoffice.com/?ref=aitripgen-share';

export const CONCIERGES = {
  classic: {
    id: { dev: '592652d3-841f-4dca-87ec-7ce17a59bfa5', prod: '3f33a4fe-78a4-4de0-bc61-94f0275c4159' },
    name: 'classic',
    description: 'Tried & true spots'
  },
  social: {
    id: { dev: '963a2e52-837d-496b-93f0-e59e29616401', prod: '36d70215-c5d4-429b-a0bf-8c75a20c924a' },
    name: 'social',
    description: 'Night life & friends'
  },
  trendy: {
    id: { dev: 'a11c3b74-bffc-450e-9730-f8c66aab436e', prod: 'b3e67f6a-2736-4a0e-a302-035473f8ce34' },
    name: 'trendy',
    description: 'New & on-trends'
  },
  rustic: {
    id: { dev: '268a1fed-c32a-40e4-8654-6be954949b0d', prod: '71311a9e-d8b3-4530-bb2a-ea4b4903edeb' },
    name: 'rustic',
    description: 'Off-the-beaten-path'
  },
  unique: {
    id: { dev: 'a81b8034-9eb2-406a-9567-4f0a6707dd4a', prod: 'fd01c22e-b31f-4312-9922-0ff8fc665845' },
    name: 'unique',
    description: 'Hidden Gems'
  },
};

export const POPULAR_REGIONS = [
  { id: { dev: 'ChIJLwPMoJm1RIYRetVp1EtGm10', prod: 'ecce37f4-ba20-492b-955a-968408e321ec' }, name: 'Austin', location: 'TX, US' },
  { id: { dev: 'ChIJdySo3EJ6_ogRa-zhruD3-jU', prod: 'b2ac9d20-07e2-4589-aa36-0fac0908daae' }, name: 'Charleston', location: 'SC, US' },
  { id: { dev: 'ChIJPZDrEzLsZIgRoNrpodC5P30', prod: '50893668-0aa7-430b-b89a-851628fc36e9' }, name: 'Nashville', location: 'TN, US' },
  { id: { dev: 'ChIJJ3SpfQsLlVQRkYXR9ua5Nhw', prod: '0c276ec7-ad53-4b58-af08-3a23a3ee829a' }, name: 'Portland', location: 'OR, US' },
  { id: { dev: 'ChIJZYIRslSkIIYRtNMiXuhbBts', prod: 'c0018b66-77b2-460f-8b72-22423440ea67' }, name: 'New Orleans', location: 'LA, US' },
  { id: { dev: 'ChIJSx6SrQ9T2YARed8V_f0hOg0', prod: 'f89eae4b-4b81-43ef-94c0-a4dbda13333a' }, name: 'San Diego', location: 'CA, US' },
  { id: { dev: 'ChIJ0X31pIK3voARo3mz1ebVzDo', prod: '62142b8a-94c7-4aad-9414-73d55e08de4e' }, name: 'Las Vegas', location: 'NV, US' },
  { id: { dev: 'ChIJud3-Kxem2YgR62OUJUEXvjc', prod: '50891107-a4c1-40af-95f7-51dc9a64dfdd' }, name: 'Miami Beach', location: 'FL, US' },
  { id: { dev: 'ChIJD7fiBh9u5kcRYJSMaMOCCwQ', prod: '25f765e4-e8ab-4471-a0e0-6e049caf9077' }, name: 'Paris', location: 'FR' },
  { id: { dev: 'ChIJdd4hrwug2EcRmSrV3Vo6llI', prod: '45868894-3bc4-41fc-b394-1ddcbbc36726' }, name: 'London', location: 'GB' },
  { id: { dev: 'ChIJOwg_06VPwokRYv534QaPC8g', prod: '1f337046-182c-4f40-b078-2d9406918937' }, name: 'New York', location: 'NY, US' },
  { id: { dev: '977d3d08-759d-4d7d-8991-4009a82d441e', prod: 'bbcf0a92-29ca-4184-9ded-46f48d436cbb' }, name: 'Chicago', location: 'IL, US' },
  { id: { dev: 'ChIJE9on3F3HwoAR9AhGJW_fL-I', prod: '40ec0bb6-0921-48d0-95c2-01b9ac2b7421' }, name: 'Los Angeles', location: 'CA, US' },
  { id: { dev: 'ChIJWQbyePx1-4gRvCBgA1FnDE4', prod: '0dcd5fa6-30b8-4d64-9c18-ce7a9d34ad04' }, name: 'Savannah', location: 'GA, US' },
  { id: { dev: 'ChIJlyx3p9kIK4cRGOaPGBLk0iY', prod: '6a1b47d2-5b99-4810-939d-46f731ccb6c0' }, name: 'Scottsdale', location: 'AZ, US' },
  { id: { dev: 'ChIJGzE9DS1l44kRoOhiASS_fHg', prod: '73322460-386b-4acc-ac8b-125847c53d97' }, name: 'Boston', location: 'MA, US' },
  { id: { dev: 'ChIJSyrkEAPUT48Rt5r_k9vA7Q4', prod: '4ca780a9-db7d-4161-90eb-90d69567535e' }, name: 'Tulum', location: 'MX' },
  { id: { dev: '9e47ef67-a791-4c00-a975-eaabe68bcac1', prod: 'abeb1d58-1305-49b7-8377-0e261cf8833f' }, name: 'San Francisco', location: 'CA, US' },
  { id: { dev: 'ChIJB3UJ2yYAzoURQeheJnYQBlQ', prod: '76bb2889-c82a-4bcb-baff-2757e9a9a9c0' }, name: 'Mexico City', location: 'MX' },
  { id: { dev: 'ChIJzxcfI6qAa4cR1jaKJ_j0jhE', prod: '029811dc-df77-4e04-96e3-7e1f37c4f936' }, name: 'Denver', location: 'CO, US' },
  { id: { dev: 'ChIJW-T2Wt7Gt4kRKl2I1CJFUsI', prod: '177e3de4-6cea-4867-8e08-afcfe68c7976' }, name: 'Washington', location: 'DC, US' },
  { id: { dev: 'ChIJS5dFe_cZTIYRj2dH9qSb7Lk', prod: '08b2ff88-f6f0-46c7-a316-d52826f98b05' }, name: 'Dallas', location: 'TX, US' },
  { id: { dev: 'ChIJrdbSgKZWKhMRAyrH7xd51ZM', prod: '4a3a244c-b75b-4c99-9560-f55510126f12' }, name: 'Florence', location: 'IT' },
  { id: { dev: 'ChIJfTxB93w5QIcRcvYseNxCK8E', prod: '4de82fc6-802c-49e3-abe4-544d95977757' }, name: 'Aspen', location: 'CO, US' },
];

export const LOADING_MESSAGES = [
  'Escaping the office...',
  'Scanning for hidden gems...',
  'Packing your virtual bags...',
  'Breathing in the fresh air...',
  'Logging into vacation mode...',
  'Venturing into the unknown...',
  'Assembling the perfect trip...',
  'Bending the rules of travel...',
  'Clocking out and jetting off...',
  'Creating your dream vacation...',
  'Igniting your vacation spark...',
  'Building your dream itinerary...',
  'Crafting the ultimate getaway...',
  'Crafting your perfect getaway...',
  'Exploring your travel options...',
  'Fostering your inner explorer...',
  'Setting your vacation compass...',
  'Discovering unique experiences...',
  'Dreaming up the perfect escape...',
  'Finding your dream destination...',
  'Scouting top-rated attractions...',
  'Brewing your vacation daydreams...',
  'Charting a course for adventure...',
  'Curating your personalized trip...',
  'Mixing your dream vacation brew...',
  'Syncing with your travel dreams...',
  'Warming up your vacation senses...',
  'Fine-tuning your vacation vision...',
  'Orchestrating your dream holiday...',
  'Syncing with your inner traveler...',
  'Working hard, vacationing harder...',
  'Assembling your dream travel team...',
  'Preparing your trip to relaxation...',
  'Sculpting your travel masterpiece...',
  'Tapping into the travel zeitgeist...',
  'Breaking free from the daily grind...',
  'Channeling your inner globetrotter...',
  'Going from boardroom to beachfront...',
  'Mixing up your dream trip cocktail...',
  'Putting your work worries on pause...',
  'Setting the stage for your journey...',
  'Deciphering your travel personality...',
  'Fine-tuning your travel masterpiece...',
  'Hand-picking your travel highlights...',
  'Turning off your work notifications...',
  'Turning your OOO reply into reality...',
  'Leaving office blues for sunset hues...',
  'Polishing your vacation crystal ball...',
  'Bidding adieu to your ergonomic chair...',
  'Ditching the office for the open road...',
  'Infusing your getaway with excitement...',
  'Taking the scenic route to relaxation...',
  'Crafting your personalized travel plan...',
  'Elevating your vacation to new heights...',
  'Going from inbox zero to vacation hero...',
  'Leaving screens, finding serene scenes...',
  'Mixing and matching travel ingredients...',
  'Tapping into the collective wanderlust...',
  'Designing your custom travel experience...',
  'Leaving office lights for starry nights...',
  'Leaving the 9-to-5 for a 24/7 adventure...',
  'Mapping out your personalized adventure...',
  'Swapping spreadsheets for sandy beaches...',
  'Telecommuting to your dream destination...',
  'Unlocking the door to your dream escape...',
  'Weaving your travel dreams into reality...',
  'Downloading the map to your ideal escape...',
  'Gathering intel on the best travel spots...',
  'Initiating the countdown to your getaway...',
  'Plotting your ultimate getaway adventure...',
  'Stepping out of office and into paradise...',
  'Analyzing the stars to guide your journey...',
  'Becoming unbothered, focused, flourishing...',
  'Hanging up your office keys for a hammock...',
  'Imagining your next unforgettable journey...',
  'Planting the seeds for your travel garden...',
  'Preparing to launch your dream expedition...',
  'Putting your work stress on airplane mode...',
  'Swapping conference calls for beach balls...',
  'Upgrading your workspace to an ocean view...',
  'Closing your laptop, opening your suitcase...',
  'Collating your ultimate travel bucket list...',
  'Exploring the unbeaten path, far from work...',
  'Flipping through your virtual travel guide...',
  'Putting the art in artificial intelligence...',
  'Trading office politics for vacation bliss...',
  'Getting the recipe for your perfect getaway...',
  'Transporting you to a world of travel magic...',
  'Breaking free from your desk chair daydreams...',
  'Diving into the depths of travel inspiration...',
  'Farewell, florescent lights. Hello, sunshine...',
  'Finding solace in nature, not the break room...',
  'Flipping your work calendar to vacation mode...',
  'Replacing office walls with beautiful vistas...',
  'Scanning the globe for the best destinations...',
  'Spinning the globe of vacation possibilities...',
  'Clocking out of work, clocking into adventure...',
  'Hacking the algorithm to find your ideal trip...',
  'Swapping office air for fresh vacation breeze...',
  'Adjusting the lens of your travel kaleidoscope...',
  'Cruising through your perfect vacation options...',
  'Exchanging your coffee breaks for beach breaks...',
  'Trading your to-do list for a travel itinerary...',
  'Calculating the coordinates to your happy place...',
  'Connecting the dots of your travel constellation...',
  'Discovering new horizons beyond the office window...',
  'Leaving the office behind for a breath of fresh air...',
  'Taking the path less traveled, away from the office...',
  'Exchanging office small talk for the sounds of nature...',
  'Leaving the office behind, one vacation day at a time...',
  'Disconnecting from the office, reconnecting with nature...',
  'Exchanging your office view for a breathtaking panorama...',
];
